<template>
  <teams-wrapper
    class="slack-wrapper"
    :sendTestMessageButtonDisabled="sendTestMessageButtonDisabled"
    @sendTestMessage="$emit('sendTestMessage')"
  >
    <div class="p-3">
      <div class="mb-2 text-wrapper" v-if="introText" v-html="introText"></div>
      <b-card>
        <div class="mb-2 pt-3">
          <p><span class="mr-3">🥇</span><span class="mr-3">John Doe</span><span class="mr-3">...</span><span class="mr-3">2568points</span></p>
          <p><span class="mr-3">🥈</span><span class="mr-3">Mary Doe</span><span class="mr-3">...</span><span class="mr-3">2324points</span></p>
          <p><span class="mr-3">🥉</span><span class="mr-3">John Smith</span><span class="mr-3">...</span><span class="mr-3">2301points</span></p>
          <template v-if="isIndividual">
            <p>...</p>
            <p><span class="mr-3">34</span><span class="mr-3">{{user.fullName}}</span><span class="mr-3">...</span><span class="mr-3">1435points</span></p>
          </template>
        </div>
        <div class="mb-2 mt-3">
          <span class="ml-2 teams-button">
            <strong>{{goToPlatformButtonText}}</strong>
          </span>
        </div>
      </b-card>
    </div>
  </teams-wrapper>
</template>

<script>
import TeamsWrapper from './wrapper';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'CampaignAdminCampaigns',
  components: {
    TeamsWrapper,
  },
  props: {
    fromEmail: {
      type: String,
    },
    job: {
      type: Object,
    },
    contentShare: {
      type: Object,
    },
    inputs: {
      type: Object,
    },
    isIndividual: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapRoot([ 'user' ]),
    introText() {
      const { inputs, replaceVariables } = this;
      if (inputs && inputs.INPUT_PRE_LEADERBOARD_TEXT) {
        return replaceVariables(inputs.INPUT_PRE_LEADERBOARD_TEXT);
      }
      return null;
    },
    sendTestMessageButtonDisabled() {
      const { fromEmail } = this;
      return !fromEmail || !fromEmail.includes('@');
    },
    goToPlatformButtonText() {
      const { inputs, replaceVariables } = this;
      if (inputs && inputs.INPUT_GO_TO_PLATFORM_BUTTON_TEXT) {
        return replaceVariables(inputs.INPUT_GO_TO_PLATFORM_BUTTON_TEXT);
      }
      return null;
    },
    variables() {
      const { job, contentShare, shareLink } = this;
      return {
        FIRST_NAME: 'John',
        LAST_NAME: 'Doe',
        FULL_NAME: 'John Doe',
        LEADERBOARD_POSITION: Math.round(Math.random() * 100),
        LEADERBOARD_POINTS: Math.round(Math.random() * 500),
        JOB_TITLE: (job || {}).title || ' - ',
        JOB_DESCRIPTION: (job || {}).excerpt || ' - ',
        JOB_SHARE_TEXT: `Work with me as a ${(job || {}).title || ' - '}`,
        JOB_MATCH_LINK: (job || {}).linkedInSearchURL || ' - ',
        CONTENT_TITLE: (contentShare || {}).title || ' - ',
        CONTENT_DESCRIPTION: (contentShare || {}).description || ' - ',
        CONTENT_SHARE_TEXT: 'We are hiring. Apply to one of our openings!',
        LEADERBOARD_FIRST_POINTS: 1356,
        LEADERBOARD_SECOND_POINTS: 1110,
        LEADERBOARD_THIRD_POINTS: 936,
        LEADERBOARD_FIRST_NAME: 'John Doe',
        LEADERBOARD_SECOND_NAME: 'Mary Doe',
        LEADERBOARD_THIRD_NAME: 'Steve Doe',
        LEADERBOARD_FIRST_PRIZE_TITLE: '£1000 Amazon Voucher',
        LEADERBOARD_SECOND_PRIZE_TITLE: '£500 Amazon Voucher',
        LEADERBOARD_THIRD_PRIZE_TITLE: '£200 Amazon Voucher',
        JOB_SHARE_LINK: shareLink,
        CONTENT_SHARE_LINK: shareLink,
        PLATFORM_LINK: origin.includes('localhost') ? 'https://referrals.reallinks.dev' : origin,
      };
    }
  },
  methods: {
    replaceVariables(text) {
      const { variables } = this;
      let newText = text;
      Object.keys(variables).forEach(key => {
        newText = newText.replace(new RegExp(`{{${key}}}`, 'g'), variables[key]);
      });
      return newText;
    },
  },
};
</script>

<style lang="scss">
.slack-wrapper {
  .teams-button {
    border: 1px solid #522bff;
    border-radius: 4px;
    padding: 6px 9px;
    cursor: pointer;

    &:hover {
      background-color: #f6f6f6;
    }
  }
  .teams-button-inverse {
    background: #260c9a;
    border-radius: 4px;
    font-size: 13px;
    padding: 8px;
    color: #fff;
    cursor: pointer;
  }
  .text-wrapper {
    p {
      margin-bottom: 5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/campaign-admin/message-previews/teams/leaderboard.vue